import React from 'react'

import { Page } from '../../../components/layouts/page'
import { Column } from '../../../components/layouts/columns'
import { Icon } from '../../../components/icons'
import { ConvertTimestampToTime, DataComTraçoParaDataComBarra } from '../../../utils/dates'
import { useClientEventMessage } from './_hooks/useClientEventMessage'
import { Input } from '../../../components/ui/input'
import { Button } from '../../../components/ui/button'
import { Select } from '../../../components/ui/select'
import { TransformationforMask } from '../../../utils/masks'

export const ClientEventsMessages = () => {
  const {
    chatRef,
    dataFiltered,
    HandleSendMessage,
    inputMessage,
    setInputMessage,
    search,
    setSearch,
    HandleDeleteMessage,
    formContext,
    HandleBlockUnblockMessages,
    loading,
    optionsFilterJobOffer,
    hideTags,
    setHideTags,
  } = useClientEventMessage()
  return (
    <Page.Section className="is-fullheight-with-navbar">
      <Column.Root>
        <Column.Content className="">
          <p className="subtitle is-size-4">
            <Icon size={30} className={'mr-3'}>
              message
            </Icon>
            Mensagens do Evento
          </p>
        </Column.Content>
      </Column.Root>

      <Column.Root>
        <Column.Content>
          <p className="subtitle has-text-grey-light">{TransformationforMask(formContext.name, 'title')}</p>
        </Column.Content>
      </Column.Root>

      <Column.Root className="">
        <Column.Content>
          <Input.Root>
            <Input.Contents alignIcon={'left'}>
              <Input.Prompt
                value={search}
                setValue={setSearch}
                field={'search'}
                placeholder="Pesquisar..."
              ></Input.Prompt>
              <Input.Icon align="is-left">
                <Icon size={20}>search</Icon>
              </Input.Icon>
            </Input.Contents>
          </Input.Root>
        </Column.Content>
      </Column.Root>

      <Column.Root className="">
        <Column.Content>
          <Input.Root>
            <Input.Label>Vagas</Input.Label>
            <Select.Root>
              <Select.SearchMulti
                color="is-grey"
                className="is-fullwidth is-rounded"
                value={search}
                setValue={setSearch}
                field={'idsjobOffers'}
                required={true}
                options={optionsFilterJobOffer}
                showSelectAllButton
              ></Select.SearchMulti>
            </Select.Root>
          </Input.Root>
        </Column.Content>

        <div style={{}}></div>

        <Column.Content
          size="is-2"
          style={{ justifyContent: 'center', display: 'flex', alignItems: 'center', textAlign: 'center' }}
        >
          <Button.Root align="left" className="mt-5">
            {formContext.messages === 'open' ? (
              <div style={{ flexDirection: 'column', display: 'flex' }}>
                <Button.Bt
                  className="is-success"
                  action={async () => {
                    await HandleBlockUnblockMessages()
                  }}
                  loading={loading}
                >
                  Modo Chat
                </Button.Bt>
                <p className="is-size-7 has-text-danger">Envio de mensagens liberado</p>
              </div>
            ) : (
              <div style={{ flexDirection: 'column', display: 'flex' }}>
                <Button.Bt
                  className="is-danger"
                  action={async () => {
                    await HandleBlockUnblockMessages()
                  }}
                  loading={loading}
                >
                  Modo Quadro de Aviso
                </Button.Bt>
                <p className="is-size-7 has-text-danger">Envio de mensagens bloqueados</p>
              </div>
            )}
          </Button.Root>
        </Column.Content>
        <Column.Content size="is-2" style={{ justifyContent: 'center', display: 'flex' }}>
          <Button.Root align="left" className="mt-5">
            {hideTags ? (
              <div style={{ flexDirection: 'column', display: 'flex' }}>
                <Button.Bt
                  className="is-danger"
                  action={async () => {
                    setHideTags(false)
                  }}
                  loading={loading}
                >
                  Esconder Vagas
                </Button.Bt>
              </div>
            ) : (
              <div style={{ flexDirection: 'column', display: 'flex' }}>
                <Button.Bt
                  className="is-success"
                  action={async () => {
                    setHideTags(true)
                  }}
                  loading={loading}
                >
                  Mostrar Vagas
                </Button.Bt>
              </div>
            )}
          </Button.Root>
        </Column.Content>
      </Column.Root>

      <div className="box">
        <div ref={chatRef} className="chat-window" style={{ maxHeight: '55vh' }}>
          <div
            key={`space`}
            style={{
              height: '20px',
            }}
          ></div>
          {dataFiltered.map((msg, idx) =>
            msg?.type === 'division' ? (
              <div
                key={`division${idx}`}
                style={{
                  textAlign: 'center',
                  margin: '15px 0',
                  fontWeight: '600',
                  fontSize: '0.9rem',
                  color: '#888',
                  userSelect: 'none',
                }}
              >
                {msg?.value}
              </div>
            ) : (
              <div
                key={idx}
                className={`chat-message ${msg.user}`}
                style={{ marginBottom: '30px', position: 'relative' }}
              >
                {/* Nome do usuário */}
                <p className={`chat-name-title ${msg.user}`}>{TransformationforMask(msg.name, 'title')}</p>

                {/* Balão da mensagem */}
                <div className={`chat-bubble ${msg.user}`}>
                  {(msg?.message || '----').split('\n').map((line, i) => (
                    <React.Fragment key={i}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}

                  {/* Timestamp */}
                  <div className="timestamp">{ConvertTimestampToTime(msg.timestamp)}</div>

                  {/* Botão de excluir */}
                  <button onClick={() => HandleDeleteMessage(msg)} title="Excluir">
                    ✖
                  </button>
                </div>

                {/* Tags abaixo do balão */}
                {
                  <div className={`tags-container ${msg.user}`}>
                    {(msg?.jobOffers || []).length >= optionsFilterJobOffer.length ||
                    (msg?.jobOffers || []).length === 0 ? (
                      !hideTags && msg.user === 'admin' ? null : (
                        <span className="tag is-light">A Todos</span>
                      )
                    ) : (
                      msg.jobOffers.map((tag) => {
                        const job = formContext?.jobOffers?.find((job) => job.id === tag)
                        if (!hideTags && msg.user === 'admin') return null
                        return (
                          <span key={'tag ' + tag} className="tag is-light">
                            {job.position.nome} - {DataComTraçoParaDataComBarra(job.date)} - {job.round}
                          </span>
                        )
                      })
                    )}
                  </div>
                }
              </div>
            ),
          )}
        </div>

        <div className="field has-addons mt-4">
          <div className="control is-expanded">
            <input
              className="input is-light is-rounded"
              type="text"
              placeholder="Digite sua mensagem..."
              value={inputMessage}
              onChange={(e) => setInputMessage(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && HandleSendMessage()}
            />
          </div>
          <div className="control">
            {(search?.idsjobOffers || []).length > 0 &&
            (search?.idsjobOffers || []).length < optionsFilterJobOffer.length ? (
              <button className="button is-warning is-rounded" onClick={HandleSendMessage}>
                Enviar para Vagas
              </button>
            ) : (
              <button className="button is-light is-rounded" onClick={HandleSendMessage}>
                Enviar para Todos
              </button>
            )}
          </div>
        </div>
      </div>
      <Column.Root>
        <Column.Content></Column.Content>
        <Column.Content></Column.Content>
        <Column.Content size="is-3">
          {(search?.idsjobOffers || []).length > 0 &&
          (search?.idsjobOffers || []).length < optionsFilterJobOffer.length ? (
            <div className="box notification is-warning has-text-centered">
              <p className="has-text-dark">Alerta</p>
              <p className="has-text-dark">Você esta enviando mensagem para as vagas:</p>

              {(search?.idsjobOffers || [])
                .map((idjob) => {
                  const j = optionsFilterJobOffer.find((job) => job.value === idjob)
                  return j.label
                })
                .map((tag) => {
                  return (
                    <>
                      <span key={'tag' + tag} className="tag is-dark mx-2">
                        {tag}
                      </span>
                      <br />
                    </>
                  )
                })}
            </div>
          ) : (
            <p className="has-text-grey"></p>
          )}
        </Column.Content>
      </Column.Root>
    </Page.Section>
  )
}
